import { render } from "./legend.vue?vue&type=template&id=0a51a55d&scoped=true"
import script from "./legend.vue?vue&type=script&lang=js"
export * from "./legend.vue?vue&type=script&lang=js"

import "./legend.vue?vue&type=style&index=0&id=0a51a55d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a51a55d"]])

export default __exports__